import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/services/analytics';

/**
 * Tracks GA4 page_view on every React Router navigation.
 * Mount once inside the Router (e.g. in AnalyticsProvider or Layout).
 *
 * Uses a ref to avoid duplicate fires from strict-mode double-effects
 * or rapid re-renders.
 */
export const usePageTracking = (): void => {
  const { pathname, search } = useLocation();
  const prevPath = useRef('');

  useEffect(() => {
    const fullPath = pathname + search;
    if (fullPath === prevPath.current) return;
    prevPath.current = fullPath;
    trackPageView(fullPath);
  }, [pathname, search]);
};
